module.exports = __webpack_public_path__ + "static/media/tommy1.bc37b049.svg";